import { success } from "toastr";
import {
  FETCH_PROJECT,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
  FETCH_CLIENT_PROJECT_SERVICE,
  FETCH_CLIENT_PROJECT_SERVICE_SUCCESS,
  FETCH_CLIENT_PROJECT_SERVICE_FAILURE,  
  FETCH_CLIENT_PROJECT_DROPDOWN,
  FETCH_CLIENT_PROJECT_DROPDOWN_SUCCESS,
  FETCH_CLIENT_PROJECT_DROPDOWN_FAILURE,  
  FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR,
  CREATE_PROJECT_REQUEST,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILURE,
  DELETE_CLIENT_PROJECT,
  DELETE_CLIENT_PROJECT_SUCCESS,
  DELETE_CLIENT_PROJECT_FAILURE,  
  CHANGE_PROJECT_STATUS,
  CHANGE_PROJECT_STATUS_SUCCESS,
  CHANGE_PROJECT_STATUS_FAILURE,
  FETCH_MODULE_PROJECT_DROPDOWN,
  FETCH_MODULE_PROJECT_DROPDOWN_SUCCESS,
  FETCH_MODULE_PROJECT_DROPDOWN_FAILURE,
  SAVE_PROJECT_SERVICE_MAPPING_FAILURE,
  GET_PROJECT_SERVICE_MAPPING_FAILURE,
  SAVE_PROJECT_SERVICE_MAPPING_SUCCESS,
  GET_PROJECT_SERVICE_MAPPING_SUCCESS,
  SAVE_PROJECT_SERVICE_MAPPING_REQUEST,
  GET_PROJECT_SERVICE_MAPPING_REQUEST,
  GET_PROJECT_SERVICE_LIST_FAILURE,
  GET_PROJECT_SERVICE_LIST_SUCCESS,
  GET_PROJECT_SERVICE_LIST_REQUEST,
  GET_PROJECT_STATUS_BILLING_SUCCESS,
  SAVE_PROJECT_STATUS_BILLING_SUCCESS,
  CHANGE_PROJECT_BILLING_STATUS_SUCCESS,
  GET_PROJECT_STATUS_BILLING_FAILURE,
  SAVE_PROJECT_STATUS_BILLING_FAILURE,
  CHANGE_PROJECT_BILLING_STATUS_FAILURE,
  CHANGE_PROJECT_BILLING_STATUS_REQUEST,
  SAVE_PROJECT_STATUS_BILLING_REQUEST,
  GET_PROJECT_STATUS_BILLING_REQUEST,
  GET_PROSERVICE_LIST_REQUEST,
  GET_PROSERVICE_LIST_SUCCESS,
  GET_PROSERVICE_LIST_FAILURE,
  GET_ORG_PROJECT_COUNT_FAILURE,
  GET_ORG_PROJECT_COUNT_SUCCESS,
  GET_ORG_PROJECT_COUNT_REQUEST,  
} from "./actionTypes";

const initialState = {
  project: [],
  clientProjectService:'',
  clientProjectDropdown:'',
  moduleProject: '',
  projectStatusBillingList: [],
  proserviceList: [],
  orgProjectCount: null,
  loading: false,
  error: null,
  success:false
};

const timesheetSetupProjectReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_PROJECT:
      return { ...state, loading: true };
    case FETCH_PROJECT_SUCCESS:
      return { ...state, loading: false, project: action.payload.data};
    case FETCH_PROJECT_FAILURE:
      return { ...state, loading: false, error: action.payload };
      
    case FETCH_CLIENT_PROJECT_SERVICE:
      return { ...state, loading: true, success: false, };
    case FETCH_CLIENT_PROJECT_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: false,
        clientProjectService: (action.payload?.data?.service_list).map(client => ({
          value: client.service_id,
          label: client.service_code
        })),
      };
    case FETCH_CLIENT_PROJECT_SERVICE_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    case FETCH_CLIENT_PROJECT_DROPDOWN:
      return { ...state, loading: true, success: false };
    case FETCH_CLIENT_PROJECT_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: false,
        clientProjectDropdown: {
          project_code:action.payload.data.project_code[0].project_code,
          assignTo: (action.payload?.data?.emp_list).map(client => ({
            value: client.emp_id,
            label: client.emp_code
          })),
        }          
      };    
    case FETCH_CLIENT_PROJECT_DROPDOWN_CLEAR:
      return {
        ...state,
        loading: false,
        success: false,
        clientProjectDropdown: ''
      };     
    case FETCH_CLIENT_PROJECT_DROPDOWN_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    case CHANGE_PROJECT_STATUS:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_PROJECT_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_PROJECT_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case CREATE_PROJECT_REQUEST:
      return { ...state, loading: true, success:false, error: null };
    
    case CREATE_PROJECT_SUCCESS:
      return { ...state, loading: false, success:true, deductionData: action.payload, error: null };

    case CREATE_PROJECT_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case DELETE_CLIENT_PROJECT:
      return { ...state, loading: true, success:false, error: null }; // Clear previous errors
    
    case DELETE_CLIENT_PROJECT_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };
    
    case DELETE_CLIENT_PROJECT_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };    

    case FETCH_MODULE_PROJECT_DROPDOWN:
      return { ...state, loading: true, success: false, };
    case FETCH_MODULE_PROJECT_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: false,
        moduleProject: (action.payload?.data).map(project => ({
          value: project.project_id,
          label: project.project_name,
          project_total_hours: project.project_total_hours,
          remaining_hours: project.remaining_hours,
        })),
      };
    case FETCH_MODULE_PROJECT_DROPDOWN_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    case GET_PROJECT_SERVICE_MAPPING_REQUEST:
    case SAVE_PROJECT_SERVICE_MAPPING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case GET_PROJECT_SERVICE_MAPPING_SUCCESS:
      return {
        ...state,
        loading: false,
        mappingList: action.payload,
        success: false,
      };

    case SAVE_PROJECT_SERVICE_MAPPING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case GET_PROJECT_SERVICE_MAPPING_FAILURE:
    case SAVE_PROJECT_SERVICE_MAPPING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case GET_PROJECT_SERVICE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PROJECT_SERVICE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        projectServiceList: action.payload,
      };

    case GET_PROJECT_SERVICE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_PROJECT_STATUS_BILLING_REQUEST:
    case SAVE_PROJECT_STATUS_BILLING_REQUEST:
    case CHANGE_PROJECT_BILLING_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case GET_PROJECT_STATUS_BILLING_SUCCESS:
      return {
        ...state,
        loading: false,
        projectStatusBillingList: action.payload,
        success: false,
      };

    case SAVE_PROJECT_STATUS_BILLING_SUCCESS:
    case CHANGE_PROJECT_BILLING_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case GET_PROJECT_STATUS_BILLING_FAILURE:
    case SAVE_PROJECT_STATUS_BILLING_FAILURE:
    case CHANGE_PROJECT_BILLING_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
       
     case GET_PROSERVICE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case GET_PROSERVICE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        proserviceList: action.payload,
        success: false,
      };

    case GET_PROSERVICE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

      case GET_ORG_PROJECT_COUNT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false,
        };

      case GET_ORG_PROJECT_COUNT_SUCCESS:
        return {
          ...state,
          loading: false,
          orgProjectCount: action.payload,
          success: false,
        };

      case GET_ORG_PROJECT_COUNT_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: false,
        };
    default:
      return state;
  }
};

export default timesheetSetupProjectReducer;
